import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M32.5 9c.831 0 1.5.672 1.5 1.5 0 .831-.669 1.5-1.5 1.5h-.725l-1.5 20.294A4.003 4.003 0 0 1 26.288 36H13.713a4.002 4.002 0 0 1-3.987-3.706L8.222 12H7.5a1.5 1.5 0 0 1 0-3h4.364l2.292-3.441A3.503 3.503 0 0 1 17.07 4h5.862c1.169 0 2.263.585 2.913 1.559L28.137 9H32.5ZM17.069 7c-.163 0-.375.084-.413.223L15.47 9h9.062l-1.187-1.777A.502.502 0 0 0 22.93 7H17.07Zm11.7 5H11.23l1.488 20.075a1 1 0 0 0 .994.925h12.575a1 1 0 0 0 .993-.925L28.77 12Z" })
});
export default SvgTrash;
